var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6046 10.2672H27.4419C26.6791 10.2672 26.0465 9.57056 26.0465 8.73048C26.0465 7.89039 26.6791 7.19373 27.4419 7.19373H38.6046C39.3674 7.19373 40 7.89039 40 8.73048C40 9.57056 39.3674 10.2672 38.6046 10.2672Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83721 10.2672H1.39535C0.632558 10.2672 0 9.57056 0 8.73048C0 7.89039 0.632558 7.19373 1.39535 7.19373H8.83721C9.6 7.19373 10.2326 7.89039 10.2326 8.73048C10.2326 9.57056 9.6 10.2672 8.83721 10.2672Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2791 17.4387C11.9256 17.4387 8.3721 13.5251 8.3721 8.73046C8.3721 3.93581 11.9256 0.0222168 16.2791 0.0222168C20.6326 0.0222168 24.1861 3.93581 24.1861 8.73046C24.1861 13.5251 20.6326 17.4387 16.2791 17.4387ZM16.2791 3.09572C13.4512 3.09572 11.1628 5.61598 11.1628 8.73046C11.1628 11.8449 13.4512 14.3652 16.2791 14.3652C19.107 14.3652 21.3954 11.8449 21.3954 8.73046C21.3954 5.61598 19.107 3.09572 16.2791 3.09572Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6046 32.8062H31.1628C30.4 32.8062 29.7674 32.1095 29.7674 31.2694C29.7674 30.4293 30.4 29.7327 31.1628 29.7327H38.6046C39.3674 29.7327 40 30.4293 40 31.2694C40 32.1095 39.3674 32.8062 38.6046 32.8062Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5581 32.8062H1.39535C0.632558 32.8062 0 32.1095 0 31.2694C0 30.4293 0.632558 29.7327 1.39535 29.7327H12.5581C13.3209 29.7327 13.9535 30.4293 13.9535 31.2694C13.9535 32.1095 13.3209 32.8062 12.5581 32.8062Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7209 39.9778C19.3675 39.9778 15.814 36.0642 15.814 31.2695C15.814 26.4749 19.3675 22.5613 23.7209 22.5613C28.0744 22.5613 31.6279 26.4749 31.6279 31.2695C31.6279 36.0642 28.0744 39.9778 23.7209 39.9778ZM23.7209 25.6348C20.893 25.6348 18.6047 28.155 18.6047 31.2695C18.6047 34.384 20.893 36.9043 23.7209 36.9043C26.5488 36.9043 28.8372 34.384 28.8372 31.2695C28.8372 28.155 26.5488 25.6348 23.7209 25.6348Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.a2a2d20fd7aff3116df5b4469538bd58.svg";
export { ForwardRef as ReactComponent };